module.exports = __webpack_public_path__ + "img/2.941ac5a0.png";